var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.53125,
    width: 30.3923,
    height: 29.9634,
    rx: 10.5,
    fill: "white",
    fillOpacity: 0.2,
    stroke: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_16638",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 21,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.66016,
    y: 5.83691,
    width: 19.4183,
    height: 20.0249,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_16638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3714 18.8336C16.2883 18.8336 17.067 18.5027 17.7075 17.8409C18.348 17.1791 18.6683 16.3755 18.6683 15.43C18.6683 14.4845 18.3474 13.6815 17.7057 13.021C17.0639 12.3604 16.2846 12.0302 15.3678 12.0302C14.451 12.0302 13.6723 12.3611 13.0317 13.0229C12.3912 13.6847 12.0709 14.4883 12.0709 15.4338C12.0709 16.3793 12.3918 17.1823 13.0336 17.8428C13.6753 18.5034 14.4546 18.8336 15.3714 18.8336ZM15.3696 17.6847C14.7628 17.6847 14.247 17.4657 13.8222 17.0276C13.3975 16.5896 13.1851 16.0577 13.1851 15.4319C13.1851 14.8061 13.3975 14.2742 13.8222 13.8362C14.247 13.3981 14.7628 13.1791 15.3696 13.1791C15.9764 13.1791 16.4922 13.3981 16.917 13.8362C17.3418 14.2742 17.5542 14.8061 17.5542 15.4319C17.5542 16.0577 17.3418 16.5896 16.917 17.0276C16.4922 17.4657 15.9764 17.6847 15.3696 17.6847ZM15.3706 21.2725C13.5101 21.2725 11.8149 20.7432 10.2849 19.6847C8.75487 18.6263 7.62833 17.2087 6.90527 15.4319C7.62833 13.6551 8.75446 12.2375 10.2837 11.1791C11.813 10.1206 13.508 9.59131 15.3686 9.59131C17.2291 9.59131 18.9244 10.1206 20.4544 11.1791C21.9844 12.2375 23.1109 13.6551 23.834 15.4319C23.1109 17.2087 21.9848 18.6263 20.4556 19.6847C18.9263 20.7432 17.2313 21.2725 15.3706 21.2725ZM15.3696 20.0209C16.8934 20.0209 18.2925 19.6072 19.5668 18.7798C20.8411 17.9524 21.8154 16.8364 22.4897 15.4319C21.8154 14.0274 20.8411 12.9114 19.5668 12.084C18.2925 11.2566 16.8934 10.8429 15.3696 10.8429C13.8458 10.8429 12.4468 11.2566 11.1724 12.084C9.89812 12.9114 8.92383 14.0274 8.24959 15.4319C8.92383 16.8364 9.89812 17.9524 11.1724 18.7798C12.4468 19.6072 13.8458 20.0209 15.3696 20.0209Z",
    fill: "#071E3E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.e0b5666fb2a61e58bc24c842d64268a0.svg";
export { ForwardRef as ReactComponent };